import React, { useCallback } from 'react';
import {
  IWork,
  LeftDrawerContentContainer,
  TOOLBAR_HEIGHT,
  useHeaderHeight,
  usePageLayoutStore,
} from '@diana/core';
import { EntitySectionGroups } from './EntitySectionGroups';

export const Contents = ({ thing }: { thing: null | IWork }) => {
  const setIsLeftDrawerOpen = usePageLayoutStore((store) => store.setIsLeftDrawerOpen);

  const onDrawerClose = useCallback(() => setIsLeftDrawerOpen(false), [setIsLeftDrawerOpen]);
  const headerHeight = useHeaderHeight() + TOOLBAR_HEIGHT + 11;

  return (
    <LeftDrawerContentContainer sx={{ height: `calc(100vh - ${headerHeight}px)` }}>
      {thing ? <EntitySectionGroups thing={thing} closeDrawer={onDrawerClose} /> : null}
    </LeftDrawerContentContainer>
  );
};
